<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12 module-title">LOGIN</div>
      <div class="col-lg-12" v-if="!firstLetter">
        <div class="name-description">
          Wat is je naam?
        </div>
        <div class="letter-container">
          <div v-for="letter in letters" class="letter-box" v-on:click="selectFirstLetter(letter)">
            <div class="letter-btn" :class="{available: possibleLetters.indexOf(letter) !== -1}">
              <table style="width: 100%; height: 100%;">
                <tr>
                  <td style="text-align: center; vertical-align: middle;">
                    {{letter}}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12" v-if="firstLetter && !user">
        <div class="name-description">
          Wat is je naam?
        </div>
        <div v-for="user in selectedUsers" class="user-username" v-on:click="selectUser(user)">
          {{user.firstName}} {{user.lastName}}
        </div>
      </div>

      <div class="col-lg-12" v-if="user">
        <div class="user-username">
          {{user.firstName}} {{user.lastName}}<br />
        </div>
        <div class="user-username">
          Toegangscode:<br /><br />
          <div class="code">
            <div class="code-box" v-html="code.length > 0 ? '*' : ''"></div>
            <div class="code-box" v-html="code.length > 1 ? '*' : ''"></div>
            <div class="code-box" v-html="code.length > 2 ? '*' : ''"></div>
            <div class="code-box" v-html="code.length > 3 ? '*' : ''"></div>
            <div class="code-box" v-html="code.length > 4 ? '*' : ''"></div>
          </div>
          <div class="number-input-block">
            <table cellpadding="1" cellspacing="0" style="width: 100%; height: 100%;">
              <tr>
                <td class="number-input-control"><div v-on:click="selectNumberCode('1')">1</div></td>
                <td class="number-input-control"><div v-on:click="selectNumberCode('2')">2</div></td>
                <td class="number-input-control"><div v-on:click="selectNumberCode('3')">3</div></td>
              </tr>
              <tr>
                <td class="number-input-control"><div v-on:click="selectNumberCode('4')">4</div></td>
                <td class="number-input-control"><div v-on:click="selectNumberCode('5')">5</div></td>
                <td class="number-input-control"><div v-on:click="selectNumberCode('6')">6</div></td>
              </tr>
              <tr>
                <td class="number-input-control"><div v-on:click="selectNumberCode('7')">7</div></td>
                <td class="number-input-control"><div v-on:click="selectNumberCode('8')">8</div></td>
                <td class="number-input-control"><div v-on:click="selectNumberCode('9')">9</div></td>
              </tr>
              <tr>
                <td></td>
                <td class="number-input-control"><div v-on:click="selectNumberCode('0')">0</div></td>
                <td class="number-input-control"><div v-on:click="removeNumberCode()">&lArr;</div></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    created () {
      this.refreshUsers()
    },
    beforeDestroy () {
    },
    data () {
      return {
        firstLetter: null,
        users: [],
        code: '',
        user: null,
        letters: [
          'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
          'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
        ]
      }
    },
    computed: {
      selectedUsers () {
        let users = []

        for (let user of this.users) {
          if (user.firstName.substr(0, 1).toUpperCase() === this.firstLetter) {
            users.push(user)
          }
        }

        return users
      },
      possibleLetters () {
        let possibleLetters = []

        for (let user of this.users) {
          let firstLetter = user.firstName.substring(0, 1).toUpperCase()

          if (possibleLetters.indexOf(firstLetter) === -1) {
            possibleLetters.push(firstLetter)
          }
        }

        return possibleLetters
      }
    },
    methods: {
      refreshUsers () {
        this.$http.get(process.env.API_URL + '/users', {withCredentials: true}).then(response => {
          this.users = response.body
        }, response => {
          if (response.body.errors) {
            this.error = response.body.errors.join(',')
          } else {
            this.error = 'Onverwachte fout, probeer het later opnieuw'
          }
        })
      },
      selectFirstLetter (letter) {
        if (this.possibleLetters.indexOf(letter) !== -1) {
          this.firstLetter = letter
        }
      },
      selectUser (user) {
        this.user = user
      },
      selectNumberCode (number) {
        this.code = this.code + number

        if (this.code.length === 5) {
          this.$store.dispatch('authenticate', {code: this.code, username: this.user.username}).then(() => {
            this.user = null
            this.firstLetter = null
            this.code = ''
          }, () => {
            this.code = ''
          })
        }
      },
      removeNumberCode () {
        if (this.code.length > 0) {
          this.code = this.code.substr(0, -1)
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a:hover {
    cursor: pointer;
  }

  .module-title {
    background-color: #ff8535;
    color: #fff;
    font-size: 20px;
    line-height: 40px;
  }

  a:hover {
    cursor: pointer;
  }

  .name-description {
    background-color: #fff;
    margin-top: 15px;
    padding: 10px;
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

  .user-username {
    background-color: #fff;
    margin-top: 15px;
    padding: 15px;
    width: 100%;
    font-size: 16px;
    text-align: center;
  }

  .product-info table {
    width: 100%;
  }

  .code {

  }

  .code-box {
    background-color: #eee;
    display: inline-block;
    height: 35px;
    width: 35px;
    margin-left: 10px;
    margin-right: 10px;
    font-size: 35px;
    line-height: 45px;
    overflow: hidden;
    color: #000;
  }

  .number-input-block {
    height: 50vh;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    border-top: 1px solid #ddd;
  }

  .number-input-block table {
    border-spacing: 3px;
    border: 1px solid #fff;
    border-collapse: separate;
  }

  td.number-input-control {
    border: 1px solid #fff;
    border-collapse: separate;
    width: 33%;
    vertical-align: middle;
    padding: 2px;
    font-size: 20px;
    background-color: #ff8535;
    color: #fff;
  }

  .letter-container {
    display: flex;
    top: -40px;
    padding-top: 113px;
    padding-bottom: 15px;
    position: absolute;
    left: 15px;
    right: 15px;
    height: 100vh;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
    align-content: space-between;
    overflow: hidden;
  }

  .letter-box {
    display: block;
    width: 25%;
    height: 14.27%;
    padding: 5px;
    vertical-align: middle;
    position: relative;
  }

  .letter-btn.available {
    background-color: #ff8535;
  }

  .letter-btn {
    width: 100%;
    height: 100%;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    display: inline-block;
    line-height: calc(100%);
  }

  @media (orientation: landscape) {
    .letter-box {
      width: 14.27vw;
      height: 25vh;
    }
  }

  .product-info table td,
  .product-info table th {
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserAuthentication.vue